export default {
  namespaced: true,
  state: {
    recherche: [],
    pagination: null,
    infoRecherche: {
      id: null,
      titre: null,
      recherche: null,
    },
    tab: 0,
  },
  mutations: {
    sauvegardeRecherche(state, payload) {
      state.recherche = payload.recherche;
      state.tab = payload.tab;
      state.pagination = payload.pagination;
      state.infoRecherche = payload.infoRecherche;
    },
  },
};
